<template>
    <div style="padding-top: 1rem;">
        
        <div class="text-center animate__animated animate__zoomIn">
            <p class="heading blue--text text-center">{{"Process of Buying Land"}}</p>
        </div>
        <v-row class="no-gutters">
            <v-col class="col-12 px-2">
                A few malicious land-selling enterprises have painted the buying process to be confusing. 
                However, the confusion is a deliberate tactic, “if you cannot convince them, confuse them.” 
                The process of buying land need not be rocket science, and if it seems so, then it should be a red flag, other red flags 
                <a href="/blog/red-flags">here.</a> 
                Here are the ten steps to get you to the `land owner`` status.
            </v-col>

            <v-col class="offset-4 col-4 d-flex justify-center">
                <v-img class="rounded lighten-4"
                contain
                :src="require(`../assets/genuine.jpeg`)"
                />
            </v-col>
            <v-col class="col-12 px-2">
                <p class="blue--text mt-2 sub-heading">{{"Identify Land"}}</p>
            </v-col>
            <v-col class="col-12 px-2">
                <span class="pl-4">
                    There are many genuine options in the market. 
                    This fact informs the first step. Do your research guided by the intended use of the land. 
                    Some of the vital things to consider are location, price and neighbours. 
                    Once a parcel piques your interest, engage with the company`s representatives and ask all the questions you might have. 
                    It is also advisable to follow your instincts here.
                </span>
            </v-col>

            <v-col class="col-12 px-2">
                <p class="blue--text mt-2 sub-heading">{{"Arrange a Site Visit"}}</p>
            </v-col>
            <v-col class="col-12 px-2">
                <span class="pl-4">
                    You must see what you are buying before paying a single coin. 
                    Therefore, once satisfied with the land, on paper, make an effort to visit the land. 
                    Some companies offer site visits at predetermined times; for others, you must make local arrangements with the company. 
                    Some prospective buyers, such as those in the diaspora, may not be able to do a site visit, and that is fine too; they may send their representatives to the country or disregard this step altogether.
                </span>
            </v-col>

            <v-col class="col-12 px-2">
                <p class="blue--text mt-2 sub-heading">{{"Get Documents"}}</p>
            </v-col>
            <v-col class="col-12 px-2">
                <span class="pl-4">
                    Once satisfied with the land visit, source for all the relevant documents. These documents are:
                    <ul>
                        <li>A copy of the title deed.</li>
                        <li>Map</li>
                        <li>Subdivision scheme</li>
                        <li>Pin/Location</li>
                    </ul>
                </span>
            </v-col>

            <v-col class="col-12 px-2">
                <p class="blue--text mt-2 sub-heading">{{"Engage Surveyor"}}</p>
            </v-col>
            <v-col class="col-12 px-2">
                <span class="pl-4">
                    Most buyers skip this step to cut costs; such a move needs to be revised. 
                    Trust but verify. Once you get all the relevant documents, engage a surveyor's services to verify the land's location.
                </span>
            </v-col>
            
            <v-col class="col-12 px-2">
                <p class="blue--text mt-2 sub-heading">{{"Land Search"}}</p>
            </v-col>
            <v-col class="col-12 px-2">
                <span class="pl-4">
                    A land search is a <b>MUST!</b>
                    The results of a land search give you a wealth of information about the land you are looking to buy. 
                    The information contained in a land search includes:
                    <ul>
                        <li>Nature of the title deed.</li>
                        <li>Approximate area.</li>
                        <li>Ownership Details.</li>
                        <li>Encumbrance – lease / charge</li>
                    </ul>
                </span>
            </v-col>
            
            <v-col class="col-12 px-2">
                <p class="blue--text mt-2 sub-heading">{{"Engage a Lawyer"}}</p>
            </v-col>
            <v-col class="col-12 px-2">
                <span class="pl-4">
                    If the information from the land search does not raise any alarm, then engage a lawyer. 
                    Have a lawyer draft a land agreement and have it signed. 
                    It is essential to use your lawyer to read through all the terms carefully, seeking clarification on any clause you do not understand, especially the breach of contract and termination clauses. 
                    You may otherwise use the company’s lawyer at no extra cost; however, if you do, ensure you get a copy of the agreement after making your payment.
                </span>
            </v-col>
            
            <v-col class="col-12 px-2">
                <p class="blue--text mt-2 sub-heading">{{"Pay"}}</p>
            </v-col>
            <v-col class="col-12 px-2">
                <span class="pl-4">
                    Payment, naturally, comes among the last steps. 
                    This step is interchangeable with the previous one; they may happen simultaneously too. Make your payment as stipulated in your agreement. 
                    This pay should be through Mpesa or Banks for record keeping. <b>NEVER PAY CASH.</b>
                </span>
            </v-col>
            
            <v-col class="col-12 px-2">
                <p class="blue--text mt-2 sub-heading">{{"Finalize Purchase"}}</p>
            </v-col>
            <v-col class="col-12 px-2">
                <span class="pl-4">
                    Once you have paid, sign all documents given by the land-selling company and avail all the required documents to facilitate the land transfer. The documents required for this are:
                    <ul>
                        <li>National ID</li>
                        <li>KRA PIN</li>
                        <li>Passport Photos</li>
                    </ul>
                </span>
            </v-col>

            <v-col class="col-12 px-2">
                <p class="blue--text mt-2 sub-heading">{{"Wait"}}</p>
            </v-col>
            <v-col class="col-12 px-2">
                <span class="pl-4">
                    Land registries have different waiting times but typically range between 3 – 6 months. Talk to the selling company`s agents often to check on progress.
                </span>
            </v-col>
            
            <v-col class="col-12 px-2">
                <p class="blue--text mt-2 sub-heading">{{"Collect Title Deed"}}</p>
            </v-col>
            <v-col class="col-12 px-2">
                <span class="pl-4">
                    After the 3-6 months, collect your title deed and keep it safe. You are now officially the owner of that land.
                </span>
            </v-col>
      </v-row>
    </div>
</template>
<script>
export default {
    name: 'howtoBuy'    
}
</script>
<style lang="">
    
</style>